import constants from '@playcastdotio/GlobalConfig';
import { Link } from 'react-router-dom';
import { PageBody, library } from '@playcastdotio/ArticleContent';
import { Button } from '@playcastdotio/Shadcn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { download, setAutoDownloadFlag } from '../../utility/api';
import { faWindows } from '@fortawesome/free-brands-svg-icons';
import { isMobileDevice } from '../../utility/utility';
import { useEffect } from 'react';
import { usePavilion } from '../contexts/PavilionContext';
import { SignedIn, SignedOut, SignInButton } from '@clerk/clerk-react';

export const Changelog = () => {
  const { isPavilionMode } = usePavilion();
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className='bg-content text-content-text m-0 h-auto w-full p-0'>
      <div className='bg-hero bg-content text-content-text m-0 h-auto w-full bg-cover bg-no-repeat p-0'>
        <div className='container mx-auto h-auto w-full px-8 pb-8 pt-20'>
          <section id='hero' className='grid grid-cols-12 gap-x-4 gap-y-8'>
            <div className='grid-rows col-span-full grid content-center gap-y-4 md:col-span-6 lg:gap-y-8'>
              <h1 className='row-auto text-3xl font-bold lg:text-4xl'>Changelog</h1>
              <p>Playcast is now officially live! </p>
              <p className='-mt-4'>
                Please give us your feedback in Discord; hopefully you find each version better than the last. But don't hesitate to report
                our bugs!{' '}
              </p>
              <div className='row-auto flex flex-row gap-2'>
                {!isMobileDevice() && (
                  <Button className='flex space-x-2 rounded-full' onClick={() => download()}>
                    <FontAwesomeIcon icon={faWindows} className='text-2xl' />
                    <span>Download v{constants.VERSION}</span>
                  </Button>
                )}
              </div>
            </div>

            <div className='col-span-full content-center md:col-span-5 md:col-start-8'>
              <img src='/images/preview-image.png' alt='screenshot' />
            </div>
          </section>
        </div>
      </div>
      <div className='bg-content-secondary text-content-text m-0 h-auto w-full'>
        <div className='container mx-auto h-auto w-full px-0 py-20'>
          <section id='features' className='flex flex-col gap-10 px-4 md:gap-8 md:px-4 lg:px-20 xl:px-56'>
            <p className='text-xl'>
              We have moved the Changelog into the{' '}
              <Link to='/news' className='font-bold text-yellow-500 underline underline-offset-2'>
                News
              </Link>{' '}
              section.
            </p>
            <h2 className='col-span-10 col-start-2 text-3xl'>Releases</h2>
            <PageBody article={library.pages.changelog} />
          </section>
        </div>
      </div>
    </div>
  );
};
